import { formatLargeNumber, formatPrice, stripChainName } from "../utils/formatUtils";
import ChangeIndicator from "./ChangeIndicator";
import ChevronDownIcon from "../assets/chevron-down.svg";
import ChevronUpIcon from "../assets/chevron-up.svg";

export default function TableRowSummary({ image, name, symbol, price, change_percentage_24h, marketCap, volume, isExpanded, onClick }) {
  let displayName = name;
  if (name === "Binance Bridged USDT (BNB Smart Chain)") {
    displayName = stripChainName(name);
  }
  return (
    <tr onClick={onClick} className={`text-sm text-right border-b cursor-pointer lg:hover:bg-blue-50 ${isExpanded ? 'bg-stone-50 border-none' : 'border-stone-200'}`}>
      <td className="flex items-center gap-x-3 text-left py-6 lg:pl-4">
        <img src={image} alt="coin logo" className="w-6 h-6 rounded-full" />
        <div className="flex flex-col">
          <span className="font-bold lg:max-w-40">{displayName}</span>
          <span className="text-stone-400 uppercase">{symbol}</span>
        </div>
      </td>
      <td className="py-6">${formatPrice(price)}</td>
      <td className="py-6"><ChangeIndicator value={change_percentage_24h} /></td>
      <td className="hidden lg:table-cell py-6">${formatLargeNumber(marketCap)}</td>
      <td className="hidden lg:table-cell py-6 pr-4">${formatLargeNumber(volume)}</td>
      <td className="lg:hidden py-6">
        <button>
          <img src={isExpanded ? ChevronUpIcon : ChevronDownIcon} alt="chevron icon" />
        </button>
      </td>
    </tr>
  )
};